function composedPath(event) {
  if (event.path) {
    return event.path
  }
  if (event.composedPath && event.composedPath()) {
    return event.composedPath()
  }
  let el = event.target
  const path = []

  while (el) {
    path.push(el)

    if (el.tagName === 'HTML') {
      path.push(document)
      path.push(window)

      return path
    }

    el = el.parentElement
  }
}

export default composedPath
